// extracted by mini-css-extract-plugin
export default {"fulltextSearch":"fulltextSearch__BfhyzW"};